import { createAction } from 'typesafe-actions';
import { NavBarState } from '../reducer';

export const setNavBar = createAction('NAVBAR/SET', (resolve) => {
  return (payload: Partial<NavBarState>) => resolve(payload);
});
